import React, { Component } from "react";
import {mapDisabilitySteps,uploadFileInstruction,mapType,reviewInstruction} from '../../../utils/constants';
import Steps from '../../Steps/Steps';
import UploadFile from '../Components/UploadFile/UploadFile';
import MatchColumns from '../Components/MatchColumns/MatchColumns';
import Review from '../Components/Review/Review';
import MapColumns from '../Components/MapColumns/MapColumns';
import groupBy from 'lodash/groupBy';
import find from 'lodash/find';
import uniqBy from 'lodash/uniqBy';
import remove from 'lodash/remove';
import findIndex from 'lodash/findIndex';
import flatten from 'lodash/flattenDeep';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import { deepClone } from "../../../utils/copyObject";
import axios from '../../../axios';
import * as url from '../../../utils/url';

export default class MapDisability extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTerm : '',
      sortType : 'unmapped-first',
      disabilityOptions : [],
      perMapping:[],
      error:false
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let options 
    const orgID = this.props.user.organizationId._id
    console.log("COMPONENT DID MOUNT")

    axios.get(url.getMasterListByCategory('DISABILITY')).then(({data}) => {
      console.log(data)
      const payload = data.data[0].docs;
      // console.log(payload)
       options = payload.map((i) => {
        const o = {};
        o.value = i._id;
        o.label = i.name;
        return o;
      });
      this.setState({
        disabilityOptions : options
      })
    })
}

  handleFileUpload = (fields, data, file) => {
    const {matchedColumn} = this.props.mapDisability;
    
    // console.log("fields : ",fields,"includes : ",file, '--', data);
    if(matchedColumn.length > 0) {
      if(!fields.includes(matchedColumn)) {
        this.props.onMatchColumn("");
      }
    }
    this.props.onProcessedFileUploadData(fields, data, file);
    this.props.nextStep();
    // console.log("on handle file upload");
  }

  handleMapDisabilityContinue = () => {
    const prevMap = this.state.perMapping
    let err = this.state.error
    let {allDisabilityMapping} = this.props.mapDisability;
    const invalidRecords = filter(allDisabilityMapping,(o) => o.mapped && !o.column && o.column!=="");
    // console.log('invalid ---', invalidRecords)
    if(invalidRecords.length>0){
      this.setState({error:"Please map previously mapped values"})
      return
    } else {
      this.setState({error:false})
        this.props.nextStep()
    }
  }

  handleDisabilityMapped = (disability,column) => {
    // console.log(performance,"--p---", column)
    const {allDisabilityMapping} = this.props.mapDisability;
    let allDisability = deepClone(allDisabilityMapping);
    const i = findIndex(allDisability,{value : disability.value});
    allDisability.splice(i,1,{value:disability.value,column:column, mapped:disability.mapped})
    this.props.saveAllDisabilityMapping(allDisability);
  }

  handleMatchDisabilityColumn = (matchedColumn) => {
    let {rowData,allDisabilityMapping} = this.props.mapDisability;
    const {isRepeatFlow} = this.props;
    const uP = Object.keys(groupBy(rowData,(r) => r[matchedColumn]));
    const uniqueDisability = uP.filter(e => e!=="null")
    // console.log(uniquePerformance, isRepeatFlow);
    // console.log(allPerformanceMapping);
    this.props.onMatchColumn(matchedColumn);
    let options = this.state.disabilityOptions
    const orgID = this.props.user.organizationId._id


    if(isRepeatFlow) {
      axios.get(url.getExistingMappings(orgID)).then(({data}) => {
        const payload = data.data;
        let {mapping} = payload;
        // console.log('mppaing --- ', mapping)
        if(mapping.disability && mapping.disability.data ){
          allDisabilityMapping=[]
          // console.log('inside')
          mapping.disability.data.map(e=>{
            let column = e.key
            let obj;
              e.values.map(c=>{
                let cVal = find(options, {label:e.reference.name})
                // console.log('va--', cVal)
                obj = {column:{value: cVal.value, label:e.reference.name}, value: c, mapped:true}
                return allDisabilityMapping.push(obj)
              })
          })
        console.log('all ---', allDisabilityMapping)
        this.props.saveAllDisabilityMapping(allDisabilityMapping)  

        if(allDisabilityMapping.length>0){
          const filteredMapping = uniqueDisability.map((f) => {
            const found = find(allDisabilityMapping,(o) => o.value === f);
            if(found) {
              return {
                value : f,
                column : found.column,
                mapped:true
              }
            } else {
              return {
                value : f,
                column : '',
                mapped:false
              }
            }
          })
         
           console.log(filteredMapping,'--',allDisabilityMapping);
           let results = allDisabilityMapping.concat(filteredMapping)
           let res = results.filter(e=> e.value!=null && e.value!='null').map(e=>{
             if(e.column!==""){
               let obj = {
                 value:e.value,
                 mapped: e.mapped,
                 column: {label:e.column!==""?e.column.label:"",value: e.column?e.column.value:""}
               }
               return obj
             } else {
               let val = e.value===undefined||e.value===null ||e.value==="null"|| e.value==="undefined"? e.value="empty":e.value
               let obj = {
                 value:val,
                 mapped: false,
                 column: ""
               }
               return obj
             }
           })
           res = uniqBy(res, 'value')
           this.props.saveAllDisabilityMapping(res);
           this.props.nextStep();
        } else {
        this.props.saveAllDisabilityMapping(sortBy(filter(uniqueDisability,(p) => p != 'undefined').map((p) => {
          const g = {};
          g.value = p;
          g.column = ''
          return g;
        }),(o) => o.value));
        this.props.nextStep();
      }
    } else {
      this.props.saveAllDisabilityMapping(sortBy(filter(uniqueDisability,(p) => p != 'undefined').map((p) => {
        const g = {};
        g.value = p;
        g.column = ''
        return g;
      }),(o) => o.value));
      this.props.nextStep();
    }
    })
  }else {
    this.props.saveAllDisabilityMapping(sortBy(filter(uniqueDisability,(p) => p != 'undefined').map((p) => {
      const g = {};
      g.value = p;
      g.column = ''
      return g;
    }),(o) => o.value));
    this.props.nextStep();
  }
  

  }

  handleSearchQueryChange = ({name,value}) => {
    this.setState({
      searchedTerm : value
    })
  }

  handleContinue = () => {
    let {allDisabilityMapping} = this.props.mapDisability;
    const {isRepeatFlow} = this.props;
    allDisabilityMapping = filter(allDisabilityMapping,(m)=> m.column)
    // console.log('pp-----', allPerformanceMapping)
    const groupedMapping = groupBy(allDisabilityMapping,(m) =>  m.column.value);
    // console.log('g mapp 109 -- ' ,groupedMapping);
    let data = [];
    for(let key in groupedMapping) {
      // console.log(groupedMapping[key]);
      data.push({
        key : key,
        values : groupedMapping[key].map((o) => o.value)
      })
    }
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")
    // console.log(data);
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")

    const {matchedColumn} = this.props.mapDisability;
    // console.log(matchedColumn);
    const payload = {
      mappingType : "disability",
      columnName : matchedColumn,
      data : data
    }
    console.log(payload);

    // return
    axios.post(url.saveMapping,payload).then(({data}) => {
      if(isRepeatFlow) {
        this.props.history.push({pathname : 'success',state : {type : 'disability'}});
        this.props.reset();
      } else {
        this.props.history.push('/setup/map-separation');
      }
    })
  }

  handleonSortChange = (sortType) => {
    this.setState({
      sortType : sortType
    });
  }

  handleSkipStep = () => {
    axios.post(url.skipStepFor('disability')).then(({data}) => {
      this.props.history.push('/setup/map-separation');
    })
  }

  render() {
    console.log(this.props);
    let {currentStep, allColumns, rowData, file, matchedColumn, 
      allDisabilityMapping} = this.props.mapDisability;
      // currentStep=currentStep?currentStep:0
      // console.log(this.props)
    const {searchedTerm,sortType,disabilityOptions} = this.state;
    const {isRepeatFlow} = this.props;
    const existingMap = this.state.perMapping

    return (
      <div className={"mb30" + isRepeatFlow ? 'mt30' : 'mt70'}>
      <div className="map-performance-title mt30 mb30">Map Disability</div>
        <Steps steps={mapDisabilitySteps} currentStep={currentStep} />
        {
          currentStep === 1 ? 
          <UploadFile
            top="mt40"
            instruction={uploadFileInstruction.mapDisability}
            allColumns={allColumns}
            rowData={rowData}
            file={file}
            type={mapType.disability}
            labelSize={4}
            labelText="File with disability information"
            allowedFileSize={20}
            uploadFileHint="(Only .csv files, maximum 20MB file size)"
            onFileUpload={this.handleFileUpload}
            onSkipStep={this.handleSkipStep}
            isRepeatFlow={isRepeatFlow}
          /> : 
          currentStep === 2 ?
            <MatchColumns
              goBack={this.props.goBack}
              top="mt40"
              instruction={`Please match the column with disability information.`}
              csvFields = {allColumns}
              csvData = {rowData}
              type={mapType.disability}
              mappingPositions={true}
              showDropdown={false}
              matchedColumns={matchedColumn!=="" ? [matchedColumn] : []}
              allowMoreColumnsMatch={false}
              nextBtnTxt='Continue'
              onMatchedColumn={this.handleMatchDisabilityColumn}
            /> : 
          currentStep === 3 ?
            <MapColumns
              allDataMapping={allDisabilityMapping}
              existingMap={existingMap}
              mapOptions={disabilityOptions}
              onRowMapped={this.handleDisabilityMapped}
              nextStep={this.handleMapDisabilityContinue}
              goBack={this.props.goBack}
              searchedTerm={searchedTerm}
              sortType={sortType}
              error={this.state.error}
              onSearchQueryChange={this.handleSearchQueryChange}
              onSortChange={this.handleonSortChange}
              type={mapType.disability}
              mapSelectPlaceholder="Map Disability"
              optionTypeTxt="Disability type"
              mappingTableHeader="Disability Name"
              searchBarPlaceholder="Search by disability name..."
              mappingSubHeaderTxt="Please map your employees' disability information to standardized categories."
            /> :
          currentStep === 4 ?
            <Review
              top="mt40"
              instruction={reviewInstruction.mapDisability}
              goBack={this.props.goBack}
              nextBtnAction={this.handleContinue}
              type={mapType.disability}
              mapOptions={disabilityOptions}
              file={file}
              nextBtnTxt={isRepeatFlow ? 'Finish' : 'Next Step'}
              isRepeatFlow={isRepeatFlow}
              reviewHeading="These are your final selections for the mapping. "
              {...this.props}/>
            :
            null
        }
    </div>
    );
  }
}